import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { APPCONFIG } from './config';
import { LayoutService } from './layout/layout.service';
import { Api } from './providers/api';
import { ViewContainerRef } from '@angular/core';
import {ToastsManager } from 'ng2-toastr';
import {CsvService} from "angular2-json2csv"
import { ngxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';

// 3rd
import 'styles/material2-theme.scss';
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';

@Component({
  selector: 'app-root',
  template: require('./app.component.html'),
  providers: [LayoutService,Api,CsvService],
})
export class AppComponent implements OnInit {
  public AppConfig: any;
  constructor(private router: Router,
    private toastr: ToastsManager,
    private vRef: ViewContainerRef,
    private _ngxZendeskWebwidgetService: ngxZendeskWebwidgetService) {


      if(localStorage.getItem(APPCONFIG.prefix+'isLoggedIn') && localStorage.getItem(APPCONFIG.prefix+'isLoggedIn') == 'true'){
        _ngxZendeskWebwidgetService.show();
        let user = JSON.parse(localStorage.getItem("currentUser"));
        _ngxZendeskWebwidgetService.identify(
          {
            name: user.firstName+'-'+user.adpCustomerInfo.companyName,
            email: user.email,
            organization: user.adpCustomerInfo.companyName
          }
        );
      }



      router.events.subscribe( (event: Event) => {

        if (event instanceof NavigationStart) {
            // Show loading indicator

            
        }
    
        if (event instanceof NavigationEnd) {
            // Hide loading indicator
            _ngxZendeskWebwidgetService.setHelpCenterSuggestions({ url: true });
          console.log(this.router.url);
        }
    
        if (event instanceof NavigationError) {
            // Hide loading indicator
            // Present error to user
            console.log(event.error);
        }
    });





      //
  // this.toastr.setRootViewContainerRef(vRef);
    }

  ngOnInit() {
    this.AppConfig = APPCONFIG;

    // Scroll to top on route change
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }



}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.component.ts